import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PremiumTrustBar from "./sections/PremiumTrustBar";
import TrustBar from "./sections/TrustBar";
import About from "./sections/About";
import ProductPresentation from "./sections/ProductPresentation";
import PremiumService from "./sections/PremiumService";
import Profile from "./sections/Profile";
import OurServices from "./sections/OurServices";
import WhoThisIsFor from "./sections/WhoThisIsFor";
import ProductFeatures from "./sections/ProductFeatures";
import DigitalPlatform from "./sections/DigitalPlatform";
import HowTheServiceWorks from "./sections/HowTheServiceWorks";
import KitchenFavorites from "./sections/KitchenFavorites";
import ServiceCards from "./sections/ServiceCards";
import SpecialtiesSupported from "./sections/SpecialtiesSupported";
import CredentialCertification from "./sections/CredentialCertification";
import ReadyToJoin from "./sections/ReadyToJoin";
import SalesBoost from "./sections/SalesBoost";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <PremiumTrustBar />
      <TrustBar />
      <About />
      <ProductPresentation />
      <PremiumService />
      <Profile />
      <KitchenFavorites />
      <ServiceCards />
      <OurServices />
      <WhoThisIsFor />
      <ProductFeatures />
      <DigitalPlatform />
      <HowTheServiceWorks />
      <SpecialtiesSupported />
      <CredentialCertification />
      <ReadyToJoin />
      <SalesBoost />
      <Faq />
      <Footer />
    </div>;
}